export default "__VITE_ASSET__95146a6a__"